import ApiClient from './ApiClient';
import axios from 'axios';

class MeetingInvitesAPI extends ApiClient {
  constructor() {
    super('meeting_invites', { accountScoped: true });
  }

  create(accountId, conversationId, accessToken, payload = {}) {
    const url = `/api/v1/accounts/${accountId}/conversations/${conversationId}/meeting_invites`;
    const headers = accessToken ? { api_access_token: accessToken } : {};
    return axios.post(url, payload, { headers });
  }

  getCalendar(params = {}) {
    return axios.get(this.url, { params });
  }

  cancel(publicId) {
    return axios.delete(`${this.url}/${publicId}`);
  }
}

export default new MeetingInvitesAPI();
